export var RiskTier;
(function (RiskTier) {
    RiskTier["NOTSET"] = "NOTSET";
    RiskTier["TRUSTED"] = "TRUSTED";
    RiskTier["LOW"] = "LOW";
    RiskTier["MEDIUM"] = "MEDIUM";
    RiskTier["MEDIUM_2"] = "MEDIUM_2";
    RiskTier["HIGH"] = "HIGH";
    RiskTier["HIGH_PLUS_4"] = "HIGH_PLUS_4";
})(RiskTier || (RiskTier = {}));
//# sourceMappingURL=RiskTier.js.map